import { hasMemberList } from 'src/constants/annualReturnFeeType';
import type { AnnualReturnSummaryRow } from 'src/types/annualReturn';

/**
 * Pure helpers for an annual return's fee-breakdown lines. Each line is one rule
 * from the API `summary`; the maths here drives the breakdown rows and the
 * fee-line members drill-down.
 */

/** Lines in display order — the order the back end intends them to appear. */
export function sortFeeLines(
  lines: readonly AnnualReturnSummaryRow[]
): AnnualReturnSummaryRow[] {
  return [...lines].sort(
    (lineA, lineB) => lineA.display_order - lineB.display_order
  );
}

/**
 * Whether a fee line can drill down to the members it applies to: its fee type
 * must carry a member list AND it must have at least one member.
 */
export function feeLineHasMembers(line: AnnualReturnSummaryRow): boolean {
  return hasMemberList(line.annual_return_fee_type_id) && (line.count ?? 0) > 0;
}

/** The per-member cost for a fee line: its total split across its member count. */
export function feeLinePerMember(line: AnnualReturnSummaryRow): number {
  if (!line.count) return 0;
  return Number(line.total) / line.count;
}
